import React, { useEffect } from "react";
import Aos from 'aos';
import 'aos/dist/aos.css';
import {
    portfolioImages
} from "../utils/images";
import { FaLinkedin, FaGithub, FaTwitter } from "react-icons/fa";
var parse = require('html-react-parser')
const Reviews = () => {
    useEffect(() => {
        Aos.init({ duration: 2000 })
    }, [])
    const reviews = [
        {
            name:'Paige Donner',
            job:'CEO of IoT Logistics, LLC',
            url:'https://www.linkedin.com/in/paigedonner/',
            icons:<FaLinkedin size={30} />,
            photo:'paige.png',
            feedback:"He is a consummate professional and he has done an incredible job with me.<br/> I included him in the team for this Polygon Ecosystem Support Grant.<br/><br/> <a href='https://forum.polygon.technology/t/introduction-frontierregistry/12029'> https://forum.polygon.technology/t/introduction-frontierregistry/12029 </a>",
        },
        
        {
            name:'Ans Pich',
            job:'Project Manager at Digital Age',
            icons:<FaLinkedin size={30} />,
            url:'https://www.linkedin.com/in/ans-pich-a0b611236/',
            photo:'/ans.jpg',
            feedback:'Lucas has got awesome leadership style and skills at web and blockchain development.<br/> As a Lead developer, he has launched Blockchain + AI project.<br/><br/> <a href="https://myai.zone/#team">https://myai.zone/#team </a> <br/><br/> I want to add Lucas on Top Developers list for future projects.'
        },
        {
            name:'William Roberts',
            job:'CEO of MightEmoji',
            url:'https://www.linkedin.com/in/wjbroberts/',
            icons:<FaLinkedin size={30} />,
            photo:'/william.png',
            feedback:"As a CTO of MightEmoji, It’s really good work he did. We were both really impressed and happy with it. <br/><br/> <a href='https://mightemoji.com/team/'/>https://mightemoji.com</a><br/><br/>And yes really I’m very grateful he has got it all working smoothly.",
        },
       
        {
            name:'Bryan Burrows',
            job:'CEO of Domain Labs',
            icons:<FaLinkedin size={30} />,
            url:'https://www.linkedin.com/in/bryanburrowsprofile/',
            photo:'/bryan.png',
            feedback:'He was a professional lead developer. We can do great things together and also be friend<br/<br/><br/> <a href ="https://domainlabs.app/team">https://domainlabs.app/</a></a>'
        },
        {
            name:'Jake Ehret',
            job:'CEO of Scribbles NFT',
            icons:<FaTwitter size={30} />,
            url:'https://twitter.com/thescribblesnft',
            photo:'jake.png',
            feedback:'Great, and responsive. I wasn’t too familiar with how the whole generative process works and the metadata, which he helped me understand and took me through the process. Glad we got to work together because I knew I could trust him and have a great final result Overall, very pleased with the work that was done, and am coming back for more<br/><br/><a href = "https://www.thescribbles.io/">https://www.thescribbles.io/</a>',
        }
    ]
    return (
        <div name="review" className=" w-full bg-[#0a192f] text-gray-300 pt-24 pb-80 ">
            <div className="max-w-[1500px]  mx-auto p-4 w-full flex flex-col justify-center min-h-full">
                <div className="pb-6 " data-aos='slide-right'  >
                    <p className="text-4xl font-bold inline border-b-4 border-pink-600">
                        Reviews..
                    </p>
                    <p className="pt-2">
                        Check out some of my reviews
                        <span className="text-pink-600">...</span>
                    </p>
                </div>
                <div className="max-w-10xl m-auto md:max-h-[200px] grid grid-cols-1 gap-10 md:gap-10 md:grid-cols-3 items-start">
                    {
                        reviews.map((val, key) => {
                            return (
                                <div className="p-5 review-text rounded h-[365px] relative justify-center items-center">
                                    <p className="text-base font-italic relative review-testi">
                                        {parse(val.feedback)}
                                    </p>
                                    <div className="flex flex-row mt-10 items-center absolute bottom-[20px]">
                                        <div className="overflow-hidden w-[56px] rounded-full">
                                            <img src={val.photo} width="56px" height="56px" alt="image" />
                                        </div>
                                        <div className="mx-5 flex flex-row justify-center items-center gap-5">
                                            <a href={val.link} target='_blank'
                                                rel='noreferrer' className=' text-blue-700 cursor-pointer'>
                                                {val.icons}
                                            </a>
                                        </div>
                                        <p className=" text-base text-fun-gray">
                                            <b className="text-fun-pink font-monospace">
                                                {val.name}
                                            </b><br/>
                                            {val.job}
                                        </p>

                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
        </div>
    );
};

export default Reviews;
